import React from 'react';
import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../app/styles/GlobalStyles";

const StyledBadge = styled.div`
    display: flex;
    min-width: 60px;
    padding: 5px 10px;
    justify-content: flex-end;
    align-items: center;
    color: ${({theme}) => theme.colors.white};
    border-radius: 8px 0 0 8px;
    font-size: 12px;
`

const StyledBadgeSale = styled(StyledBadge)`
    background-color: ${({theme}) => theme.colors.red};

    &:hover {
        background-color: ${({theme}) => theme.colors.darkRed};
    }
`
const StyledBadgeTop = styled(StyledBadge)`
    background-color: ${({theme}) => theme.colors.orange};

    &:hover {
        background-color: ${({theme}) => theme.colors.orangeDark};
    }
`
const StyledBadgeDiscount = styled(StyledBadge)`
    background-color: ${({theme}) => theme.colors.lightBlue};

    &:hover {
        background-color: #106690;;
    }
`
type BadgeType = 'sale' | 'top' | 'discount'
type BadgeProps = {
    type: BadgeType,
    title: string,
};

const Badge: React.FC<BadgeProps> = ({type, title}) => {
    const className = `${GLOBAL_STYLE_CONFIG.splitByPrefix("badge")} ${GLOBAL_STYLE_CONFIG.splitByPrefix(`badge-${type}`)}`;
    return (
        <>
            {type === "sale" && <StyledBadgeSale className={className}>{title}</StyledBadgeSale>}
            {type === "top" && <StyledBadgeTop className={className}>{title}</StyledBadgeTop>}
            {type === "discount" &&
                <StyledBadgeDiscount className={className}>{title}</StyledBadgeDiscount>}
        </>
    )
};

export default Badge;